import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class LoaderService {

    private counter = 0;
    public isLoading = new BehaviorSubject(false);

    show() {
        this.counter++;
        this.next(true);
    }

    hide() {
        this.counter--;
        this.next(this.counter !== 0);
    }

    next(value) {
        this.isLoading.next(value);

        /* TODO if disable body scroll necessary
        const body = document.getElementsByTagName('body')[0];
        if (value) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }
        */
    }
}
